var map = {
	"./gallery-wip-pommel_00.jpg": 4867,
	"./gallery-wip-pommel_01.jpg": 4868,
	"./gallery-wip-pommel_02.jpg": 4869,
	"./gallery-wip-pommel_03.jpg": 4870,
	"./gallery-wip-pommel_04.jpg": 4871,
	"./gallery-wip-pommel_05.jpg": 4872,
	"./gallery_00.jpg": 4873,
	"./gallery_01.jpg": 4874,
	"./gallery_02.jpg": 4875,
	"./gallery_03.jpg": 4876,
	"./gallery_04.jpg": 4877,
	"./gallery_05.jpg": 4878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4866;